/**
 * Header Navigation mobile toggle functionality
 */
const headerNav = {
    init() {
        this.setupMobileToggle();
        this.setupMobileSubmenus();
        this.setupResponsiveNav();
    },

    setupMobileToggle() {
        const toggleButton = document.querySelector('.header-main__toggle');
        const mobileNav = document.querySelector('.header-mobile-nav');

        if (!toggleButton || !mobileNav) {
            return;
        }

        toggleButton.addEventListener('click', () => {
            toggleButton.classList.toggle('active');
            mobileNav.classList.toggle('active');
        });

        // Close menu when clicking outside
        document.addEventListener('click', (event) => {
            const isClickInsideMenu = event.target.closest('.header-mobile-nav');
            const isClickOnToggle = event.target.closest('.header-main__toggle');
            const isClickInsideHeader = event.target.closest('.header-main__inner');

            if (!isClickInsideMenu && !isClickOnToggle && !isClickInsideHeader && mobileNav.classList.contains('active')) {
                mobileNav.classList.remove('active');
                toggleButton.classList.remove('active');
            }
        });

        // Close menu on window resize to desktop
        window.addEventListener('resize', () => {
            if (window.innerWidth >= 992) {
                mobileNav.classList.remove('active');
                toggleButton.classList.remove('active');
            }
        });
    },

    setupMobileSubmenus() {
        const menuItemsWithChildren = document.querySelectorAll('.mobile-nav__item--parent');

        menuItemsWithChildren.forEach((item) => {
            const link = item.querySelector('.mobile-nav__link');

            if (link) {
                link.addEventListener('click', (e) => {
                    e.preventDefault();
                    item.classList.toggle('active');
                });
            }
        });
    },

    setupResponsiveNav() {
        const nav = document.querySelector('.header-nav');
        if (!nav) return;

        const items = Array.from(nav.querySelectorAll(':scope > .header-nav__item'));
        const actions = document.querySelector('.header-main__actions');

        if (items.length < 5) return;

        let moreItem = null;
        let moreSubmenu = null;
        let hiddenItems = [];

        const createMoreDropdown = () => {
            if (moreItem) return;

            moreItem = document.createElement('li');
            moreItem.className = 'header-nav__item header-nav__item--parent header-nav__item--more';
            moreItem.innerHTML = `
                <a href="#" class="header-nav__link">MORE</a>
                <ul class="header-nav__sub-menu header-nav__sub-menu--more"></ul>
            `;
            moreSubmenu = moreItem.querySelector('.header-nav__sub-menu--more');
            nav.appendChild(moreItem);
        };

        const checkNavOverflow = () => {
            if (window.innerWidth < 992) {
                if (moreItem) {
                    moreItem.style.display = 'none';
                }
                items.forEach(item => item.style.display = '');
                return;
            }

            // Reset all items first
            items.forEach(item => item.style.display = '');
            if (moreItem) {
                moreItem.style.display = 'none';
                moreSubmenu.innerHTML = '';
            }
            hiddenItems = [];

            const navRect = nav.getBoundingClientRect();
            const actionsRect = actions ? actions.getBoundingClientRect() : { left: window.innerWidth };
            const maxWidth = actionsRect.left - navRect.left - 50;

            let totalWidth = 0;
            let overflowStartIndex = -1;

            items.forEach((item, index) => {
                const itemWidth = item.offsetWidth;
                totalWidth += itemWidth;

                if (totalWidth > maxWidth && overflowStartIndex === -1) {
                    overflowStartIndex = index;
                }
            });

            if (overflowStartIndex > 0 && overflowStartIndex < items.length - 1) {
                createMoreDropdown();
                moreItem.style.display = '';

                for (let i = overflowStartIndex; i < items.length; i++) {
                    items[i].style.display = 'none';
                    hiddenItems.push(items[i]);

                    const clonedItem = items[i].cloneNode(true);
                    clonedItem.className = 'header-nav__sub-menu__item';
                    clonedItem.style.display = '';
                    const link = clonedItem.querySelector('a');
                    if (link) {
                        link.className = 'header-nav__sub-menu__link';
                    }
                    moreSubmenu.appendChild(clonedItem);
                }
            }
        };

        // Initial check
        setTimeout(checkNavOverflow, 100);

        // Recheck on resize
        let resizeTimer;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(checkNavOverflow, 100);
        });
    }
};

export default headerNav;
